import React from 'react';
import { noop } from 'lodash';
import Modal from '../../components/Modal';
import Logo from '../../../../assets/images/squire-logo-light.svg';

const AppointmentPaidModal = () => (
  <Modal
    className="c-checkout-modal"
    close={noop}
  >
    <div className="c-checkout-modal__header">
      <img src={Logo} alt="Squire" />
    </div>
    <div className="c-payment-modal-tip-grid">
      <div className="u-flex-1 u-flex u-flex-column u-justify-content-space-between u-align-center u-mt">
        You already submitted a payment for this appointment. Thank you.
      </div>
    </div>
  </Modal>
);

export default AppointmentPaidModal;



// WEBPACK FOOTER //
// ./src/app/reservation/components/AppointmentPaidModal.jsx